module.exports = __webpack_public_path__ + "img/details-pos-test.e5c27eab.png";